/**
 * 总部活动相关接口
 * 当前为 mock，接口就绪后取消注释真实 request
 */
import request from '@/utils/request'


/**
 * 当前门店/用户是否在总部活动黑名单
 * @returns {Promise} data 为 boolean，true 表示在黑名单
 */
export function headquartersCouponBlacklist() {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/withdrawConfig/blacklist',
    method: 'get',
    allowRepeat: true,
  })
}

/**
 * 活动列表（下拉，HQEvent 页使用，带全局 loading）
 * @returns {Promise}
 */
export function activityList() {
  return request({
    url: '/mg/daohang-order-api/headquartersCoupon/options',
    method: 'get',
    loading: true,
    allowRepeat: true,
  })
}

/**
 * 活动列表（EventBanner 使用，允许与 HQEvent 并发，不弹全局 loading）
 * @returns {Promise}
 */
export function activityListRepeat() {
  return request({
    url: '/mg/daohang-order-api/headquartersCoupon/options',
    method: 'get',
    allowRepeat: true,
  })
}

/**
 * 门店报名参加总部优惠券活动
 * 往来单位、门店由后端从会话填充，前端只传活动编码
 * @param {Object} data - { activityCode }
 * @returns {Promise}
 */
export function registerActivity(data) {
  return request({
    url: '/mg/daohang-order-api/headquartersCoupon/register',
    method: 'post',
    data,
    loading: true,
  })
}

//根据活动获取 当前门店总部优惠券使用汇总
export function couponUsageSummary(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/headquartersCouponUseSummary',
    method: 'post',
    data,
    loading: true,
  })
}

/**
 * 用券明细分页
 * @param {Object} data - 要传 completeTimeStart,completeTimeEnd,status,refundStatuss,couponSource,hqCouponCode等
 * @returns {Promise}
 */
export function couponUsagePage(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/page',
    method: 'post',
    data,
    loading: true,
    allowRepeat: true,
  })
}





/**
 * 资金账户流水分页
 * @param {Object} data - page, pageSize, couponCode, fundTypes, beginDate, endDate（时间戳）
 * @returns {Promise}
 */
export function fundAccountPage(data) {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/page',
    method: 'post',
    data,
    loading: true,
    allowRepeat: true,
  })
}

/**
 * 资金账户统计
 * @param {Object} data - { activityCode }
 * @returns {Promise}
 */
export function fundAccountSummary(data) {
  return request({
    url: '/mg/daohang-promotion-api/hqActivity/shopFund',
    method: 'post',
    data,
  })
}

/**
 * 资金账户提现：获取微信授权二维码
 * @param {Object} params - { activityCode, phone }
 * @returns {Promise} data: { authId, qrCodeImageUrl, claimUrl, expireSeconds }
 */
export function fundAccountWithdrawQrCode(params) {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/withdrawAuth/qrCode',
    method: 'get',
    params,
    loading: true,
  })
}

/**
 * 资金账户提现：轮询微信授权结果
 * @param {Object} params - { authId }
 * @returns {Promise}
 */
export function fundAccountWithdrawAuthResult(params) {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/withdrawAuth/result',
    method: 'get',
    params,
    allowRepeat: true,
  })
}

/**
 * 资金账户提现（授权成功后提交）
 * @param {Object} data - { activityCode, amount, authId }
 * @returns {Promise}
 */
export function fundAccountWithdraw(data) {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/withdraw',
    method: 'post',
    data,
    loading: true,
  })
}

/**
 * 历史提现记录分页
 * @param {Object} data - { activityCode, page, size }
 * @returns {Promise} data: { total, items: [{ amount, statusDesc, failReason, userName, createTime, successTime }] }
 */
export function fundAccountWithdrawPage(data) {
  return request({
    url: '/mg/daohang-order-api/headquartersCouponFundAccount/withdraw/page',
    method: 'post',
    data,
  })
}
